import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Stack, Typography } from '@mui/material';
import AccessSelectionForm from '../../components/AccessSelectionForm';
import { useAuth } from '../../auth/AuthProvider';
import { t } from '../../i18n';

export default function SelectAccess() {
    const navigate = useNavigate();
    const { logout } = useAuth();
    const [error, setError] = useState(false);
    const [busy, setBusy] = useState(false);
    return (
        <Stack spacing={2.5}>
            <Typography component="h1" variant="h2" textAlign="center" color="accent.main">
                {t('Escolha a clínica e o perfil')}
            </Typography>
            <Typography textAlign="center" color="text.secondary">
                {t('Selecione o contexto em que pretende trabalhar.')}
            </Typography>
            <AccessSelectionForm onSelected={() => navigate('/', { replace: true })} />
            {error && <Alert severity="error">{t('Não foi possível terminar a sessão. Tente novamente.')}</Alert>}
            <Button type="button" disabled={busy} onClick={async () => {
                setBusy(true);
                setError(false);
                try { await logout(); } catch { setError(true); } finally { setBusy(false); }
            }}>{t('Terminar sessão')}</Button>
        </Stack>
    );
}
